<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-toolbar">
      <l-auth-button type="primary" auth="company_add_btn" @click="add_visible = true"> 添加 </l-auth-button>
      <div class="l-simple-search-container">
        <el-input placeholder="请输入企业名称" v-model="search_data.name" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
        </el-input>
      </div>
    </div>
    <l-table :data="data" v-loading="loading" row-key="id">
      <el-table-column fixed prop="index" label="序号" width="100"> </el-table-column>
      <el-table-column prop="name" label="企业名称" min-width="200"> </el-table-column>
      <el-table-column prop="shor_name" label="企业简称" min-width="200"> </el-table-column>
      <el-table-column label="企业类型" min-width="200">
        <template>
          <el-tag size="mini">报修企业</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="180"> </el-table-column>
      <el-table-column prop="update_time" label="修改时间" width="180"> </el-table-column>

      <el-table-column fixed="right" label="操作" width="250" align="center">
        <template slot-scope="{ row }">
          <el-dropdown trigger="click" @command="(command) => handleComandClick(command, row)">
            <span class="el-dropdown-link"> 其他操作<i class="el-icon-arrow-down el-icon--right"></i> </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="dev_type">设备类型管理</el-dropdown-item>
              <el-dropdown-item command="fac">维修服务商管理</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="primary" auth="org_edit_btn" @click="showEdit(row.id)"><i class="el-icon-edit"></i>编辑</l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="danger" auth="org_del_btn" @click="del(row.id)"><i class="el-icon-delete"></i>删除</l-auth-text-button>
        </template>
      </el-table-column>
    </l-table>

    <!--分页-->
    <l-page :total="count" layout="total,prev,pager,next"></l-page>

    <!--添加-->
    <l-dialog class="l-dialog-no-footer" :visible.sync="add_visible" title="添加企业" width="1000px">
      <l-company-add @on-success="onAddSucess" @on-company-add-success="getList" :visible.sync="add_visible"></l-company-add>
    </l-dialog>

    <!--编辑-->
    <l-dialog :visible.sync="edit_visible" title="编辑企业" width="500px">
      <l-org-edit @on-success="onEditSuccess" :visible.sync="edit_visible" :id="edit_id" />
    </l-dialog>

    <!--设备类型管理-->
    <l-dialog :visible.sync="dev_visible" title="设备类型管理" width="800px">
      <l-comapny-dev-type :visible.sync="dev_visible" :company-id="company_id" />
    </l-dialog>

    <!--厂家列表-->
    <l-dialog :visible.sync="fac_visible" title="维修服务商管理" width="95%">
      <l-mtc-company :visible.sync="fac_visible" :company-id="company_id" />
    </l-dialog>

    <!--高级搜索-->
    <el-drawer title="高级搜索" class="l-search-drawer" :modal="false" :visible.sync="search_visible" size="400px" :append-to-body="false" :modal-append-to-body="false" z-indx="-1">
      <div class="l-search-drawer-body">
        <el-form label-width="80px" ref="search_form" :model="search_data">
          <el-form-item label="资源名称" prop="name">
            <el-input v-model="search_data.name" placeholder="资源名称"></el-input>
          </el-form-item>
          <el-form-item label="资源标识" prop="identify">
            <el-input v-model="search_data.identify" placeholder="资源名称"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="l-search-drawer-footer">
        <el-button type="normal" @click="onReset">重置</el-button>
        <el-button type="primary" @click="onSearch">搜索</el-button>
      </div>
    </el-drawer>
  </el-card>
</template>

<script>
import Edit from "../org/Edit";
import Add from "./Add";
import CompanyIndex from "../dev_type/CompanyIndex";
import FacList from "../mtc_company/CompanyIndex";
export default {
  components: {
    [Edit.name]: Edit,
    [Add.name]: Add,
    [CompanyIndex.name]: CompanyIndex,
    [FacList.name]: FacList,
  },
  data() {
    return {
      data: [],
      count: 0,
      loading: false,
      change_state_loading: [],

      add_visible: false, //是否显示添加

      edit_visible: false, //是否显示编辑
      edit_id: 0,

      company_id: "",

      dev_visible: false, //是否显示设备类型管理

      fac_visible: false, //是否显示厂家列表

      //搜索
      search_visible: false,
      search_data: {
        name: "",
      },
      rel_search_data: {},
      show_more_search: false,
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("org_getCompanyList", {
        ...this.rel_search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //点击搜索按钮
    onSearch() {
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //修改状态
    changeState(row) {
      this.change_state_loading.push(row.id);
      this.$_invoke(`resource_updState`, {
        id: row.id,
        state: row.state,
      })
        .then((ret) => {
          row.state = ret.state;
          this.$_msg.success("修改状态成功");
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.change_state_loading = this.change_state_loading.filter(
            (item) => {
              return item != row.id;
            }
          );
        });
    },

    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getList();
    },

    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },

    //编辑成功回调
    onEditSuccess() {
      this.edit_visible = false;
      this.getList();
    },

    //显示修改密码界面
    showChangePwd(id) {
      this.change_pwd_id = id;
      this.$nextTick(() => {
        this.show_change_pwd = true;
      });
    },

    //修改密码成功回调
    onChangePwdSuccess() {
      this.show_change_pwd = false;
    },

    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`org_delete`, { id }).then(() => {
            this.$_msg.success("删除成功");
            this.getList();
          });
        })
        .catch(() => {});
    },

    //显示企业对应的设备类型
    showDev(id) {
      this.company_id = id;
      this.dev_visible = true;
    },

    //显示企业对应的维修厂家列表
    showFac(id) {
      this.company_id = id;
      this.fac_visible = true;
    },

    //处理点击下拉菜单事件
    handleComandClick(command, row) {
      switch (command) {
        case "dev_type":
          this.showDev(row.id);
          break;
        case "fac":
          this.showFac(row.id);
          break;
      }
    },
  },
};
</script>
